import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

export const createActivityMappings = defaultClient.mutation({
  url: 'omni-trafficking/v1/activity-mappings/' as const,
  method: 'POST',
  responseSchema: z.object({}),
  processResponse(data) {
    return data;
  },
  requestSchema: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
    }),
  ),
  querySchema: z.object({
    settingsId: z.string(),
  }),
  snakeCaseQueryParams: true,
});

export const deleteActivityMappings = defaultClient.mutation({
  url: 'omni-trafficking/v1/activity-mappings/delete/' as const,
  method: 'DELETE',
  responseSchema: z.object({}),
  querySchema: z.object({
    settingsId: z.string(),
    activityMappingId: z.array(z.string()),
  }),
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data;
  },
});
